module.exports = __webpack_public_path__ + "static/Future-of-Work-Template-Articles-1280-x-720-5-800x450-b06b2473ca950415143dd6f254a14209.png";